import axios from "axios";
import { API_URL, API_URL_V2, REWARD_API_URL, REWARD_API_URL_V2 } from "../constants/api";
import { handle401Error } from "./handle401Errors";
import { handle500Error } from "./handle500Errors";
import { notifyIfPermissionDenied } from "./permissionEvents";

export const defaultAxiosInstance = axios.create({
  //config 기본값 설정
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 쿠키를 포함하여 요청
});

export const defaultAxiosInstanceV2 = axios.create({
  //config 기본값 설정
  baseURL: API_URL_V2,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 쿠키를 포함하여 요청
});

export const defaultAxiosInstanceReward = axios.create({
  baseURL: REWARD_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 쿠키를 포함하여 요청
});

export const defaultAxiosInstanceRewardV2 = axios.create({
  baseURL: REWARD_API_URL_V2,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 쿠키를 포함하여 요청
});

// 요청 인터셉터 추가하기
/*
defaultAxiosInstance.interceptors.request.use(
  function (config) {
    // 요청이 전달되기 전에 작업 수행
    console.log("🚀 ~ 요청 인터셉터 ~ config:", config);
    return config;
  },
  function (error) {
    // 요청 오류가 있는 작업 수행
    console.error("🚀 ~ 요청 인터셉터 에러:", error);
    return Promise.reject(error);
  }
);
*/

// 401 응답 시 accessToken 재발급 후 같은 인스턴스로 원래 요청을 재시도한다
const retryOn401 = async (error, axiosInstance) => {
  try {
    const response = await handle401Error(error, axiosInstance);
    if (response) {
      return response;
    }
  } catch (handleError) {
    return Promise.reject(handleError);
  }
  return Promise.reject(error);
};

// 응답 인터셉터 추가하기
defaultAxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error.response && error.response.status === 401) {
      return retryOn401(error, defaultAxiosInstance);
    } else if (error.response && error.response.status === 403) {
      // 권한 거부면 /admin/access/me 재조회 (R-FE-01)
      notifyIfPermissionDenied(error);
    } else if (error.response && error.response.status === 404) {
    } else if (error.response && error.response.status === 500) {
      handle500Error(error);
    }
    return Promise.reject(error);
  },
);

// V2도 같은 캐치랭크 백엔드의 accessToken 쿠키를 사용하므로 만료 시 재발급이 필요하다
defaultAxiosInstanceV2.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error.response && error.response.status === 401) {
      return retryOn401(error, defaultAxiosInstanceV2);
    }
    if (error.response && error.response.status === 403) {
      notifyIfPermissionDenied(error);
    }
    return Promise.reject(error);
  },
);
